import { Autocomplete, TextField, Stack, Popper } from "@mui/material";
import { useFormikContext } from "formik";
import PropTypes from "prop-types";
import useStepper from "../../../hooks/useStepper";
import useUserEvent from "../../../hooks/useUserEvent";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// Custom Popper with scroll repositioning disabled
const CustomPopper = (props) => {
  return (
    <Popper
      {...props}
      placement="bottom-start"
      modifiers={[
        {
          name: "preventOverflow",
          enabled: true,
          options: {
            altBoundary: false,
            tether: false,
          },
        },
        {
          name: "flip",
          enabled: false,
        },
        {
          name: "eventListeners",
          options: {
            scroll: false,
            resize: true,
          },
        },
      ]}
    />
  );
};

const AutocompleteField = ({
  name,
  label = "Select from dropdown",
  icon,
  mt18 = true,
  options,
  getOptions,
  getOptionById,
  trackingDetails,
  disablePortal = false,
  disabled = false,
  dropdownIcon = <ExpandMoreIcon />,
  styleClass = "",
}) => {
  const { values, handleChange, setFieldValue } = useFormikContext();
  const { userTrackingMutation } = useUserEvent();
  const { trackingCode } = useStepper();

  const handleUserEvent = (element) => {
    if (element.target?.value || values[name]) {
      userTrackingMutation({
        variables: {
          ...trackingDetails,
          field_name: element.target?.name || name || "",
          field_value: element.target?.value?.toString() || values[name] || "",
          avc_track_code: trackingCode,
        },
      });
    }
  };

  return (
    <Autocomplete
      disablePortal={disablePortal}
      disabled={disabled}
      options={options}
      fullWidth
      PopperComponent={CustomPopper}
      className={`${mt18 ? "mt-18" : ""} ${styleClass}`}
      noOptionsText={`No ${name} found`}
      filterOptions={(x) => x}
      value={values[name] || null}
      onChange={(e, option) => {
        setFieldValue(name, option || null);
        getOptionById(option?.value, values);
      }}
      onInputChange={(e) => {
        e && getOptions(e.target.value);
      }}
      popupIcon={dropdownIcon}
      renderInput={(params) => (
        <TextField
          {...params}
          id={name}
          name={name}
          color="mmm"
          label={
            <Stack direction="row">
              {icon}
              {label}
            </Stack>
          }
          variant="outlined"
          onChange={() => handleChange}
          onFocus={(e) => {
            handleUserEvent(e);
          }}
          onBlur={(e) => {
            handleChange(e);
            handleUserEvent(e);
          }}
        />
      )}
    />
  );
};

AutocompleteField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.array,
  getOptions: PropTypes.func,
  getOptionById: PropTypes.func,
  icon: PropTypes.element,
  mt18: PropTypes.bool,
  trackingDetails: PropTypes.object,
  disablePortal: PropTypes.bool,
  disabled: PropTypes.bool,
  dropdownIcon: PropTypes.element,
  styleClass: PropTypes.string,
};

export default AutocompleteField;
